import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query'

import { listHodInbox, type HodInboxParams } from '../api/hodInboxApi'

// One queryOptions factory per (bucket + filters) tuple. Tabs share a
// short staleTime so switching between Open / Action Required / etc.
// doesn't refetch every time. keepPreviousData avoids the badge counts
// flickering to 0 on tab change.
export const hodInboxQueryOptions = (params: HodInboxParams) =>
  queryOptions({
    queryKey: ['hod-issues', params] as const,
    queryFn: () => listHodInbox(params),
    staleTime: 1000 * 30,
    placeholderData: keepPreviousData,
  })

export function useHodInbox(params: HodInboxParams) {
  return useQuery(hodInboxQueryOptions(params))
}
